import { Profile } from "app/helpers/globals";


export const tachosafeLocalhostProfile: Profile = {
    key: 'tachosafe-localhost',
    domains: ['localhost'],
    theme: 'tachosafe',
    apiUrl: 'http://localhost:4200/TachoSafe/',
    billingApiUrl: 'http://localhost:4200/TachoSafe/',
    chartApiUrl: 'http://localhost:4200/TachoSafe/',
    i18nUrl: 'https://i18n.tacho5safe.com',
    i18nKey: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg',
    language: {
        fallback: 'en',
        default: 'en',
    },
    showAds: true,
    websiteTitle: '🟢 TS Local 🟢',
    disabledFeatures: [],
    topBarButtons: {
        more: true,
        help: true,
        phone: true,
        rduAdmin: true,
        rduManager: true,
        t2sUpdater: true,
        tachosafeSite: true,
        changesInStructure: true,
    },
    staticFiles: {
        logoColor: 'assets/profiles/tachosafe/newLogoColored.png',
        logoBlackAndWhite: 'assets/profiles/tachosafe/newLogo.png',
        favicon: 'assets/profiles/tachosafe/favicon.ico',
        backgroundImage: 'assets/profiles/tachosafe/Login Page_Background_2400x1600.webp',
    },
    documentLinks: {
        termsOfService: 'https://tachosafe.ro/terms-and-conditions',
        cookieNotice: 'https://tachosafe.ro/cookie-policy',
        privacyPolicy: 'https://tachosafe.ro/confidentiality-policy',
    },
    noDriverVehicleBanner: 'normal',
    disabledReports: [],
    forceShowScheduledReports: false,
};